export function normalizeSerbianLettersForRegex(value: string) {
	return value
		.replaceAll(/[cčć]/gi, '[cčć]')
		.replaceAll(/[dđ]/gi, '[dđ]')
		.replaceAll(/[sš]/gi, '[sš]')
		.replaceAll(/[zž]/gi, '[zž]');
}
